// extracted by mini-css-extract-plugin
export default {"stepsWrapper":"Steps_stepsWrapper__5WPnn","overlay":"Steps_overlay__hz56X","stepsList":"Steps_stepsList__v5fI5"};